import React from 'react';
import { CTAButton } from './CTAButton';
export function Header() {
  return <header className="bg-white py-3 px-5 md:px-8 sticky top-0 z-40 shadow-sm border-b border-gray-100" data-id="element-29">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-30">
        <div className="flex items-center space-x-2" data-id="element-31">
          <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center" data-id="element-32">
            <span className="text-white font-bold text-lg" data-id="element-33">R</span>
          </div>
          <span className="font-bold text-gray-900 text-lg md:text-xl tracking-tight" data-id="element-34">
            Reinicio<span className="text-teal-600" data-id="element-35">Cortisol</span>
          </span>
        </div>
        <CTAButton text="Descargar" className="!py-1.5 !px-2.5 md:!py-2 md:!px-4 !text-[10px] md:!text-sm !rounded-md md:!rounded-lg !shadow-md !font-bold ml-3" data-id="element-36" />
      </div>
    </header>;
}